import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogState,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ModalContext } from 'stream-chat-angular';
import { NgTemplateOutlet } from '@angular/common';

export type ChatModalDialogProps = ModalContext['content'];

@Component({
  selector: 'app-chat-modal-dialog',
  templateUrl: './chat-modal-dialog.component.html',
  styleUrl: './chat-modal-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, NgTemplateOutlet],
  standalone: true,
})
export class ChatModalDialogComponent {
  data = inject<ChatModalDialogProps>(MAT_DIALOG_DATA);

  readonly dialogRef = inject(MatDialogRef<ChatModalDialogComponent>);

  public close(): void {
    this.dialogRef.close(false);
  }

  public isOpen(): boolean {
    return this.dialogRef.getState() === MatDialogState.OPEN;
  }
}
